import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';

import { FormContextValues } from '@dreryk/react-common';
import { Multiselect } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';
import { FilterFormBean } from '../../AppointmentsFilterPanel';

import {
   DOCTORS_FILTER_FIELD_NAME,
   useDoctorsFilterSearchParamHandler,
   useToggleLabelExtractor,
} from './DoctorsFilter.hooks';
import { DoctorsFilterList } from './DoctorsFilterList';
import { StyledDoctorsFilter } from './StyledDoctorsFilter.styled';

type DoctorsFilterProps = Pick<FormContextValues<FilterFormBean>, 'register' | 'setValue'> & {
   readonly currentFilters: FilterFormBean['doctors'];
   readonly doctors: DoctorSimple[];
};

export const DoctorsFilter = (props: DoctorsFilterProps): JSX.Element => {
   const { currentFilters, doctors } = props;

   const handleHide = useDoctorsFilterSearchParamHandler(currentFilters);
   const labelExtractor = useToggleLabelExtractor(doctors);

   return (
      <StyledDoctorsFilter>
         <Multiselect<DoctorSimple>
            testId={'doctors'}
            triggerLabelExtractor={labelExtractor}
            itemKeyGenerator={'practitionerId'}
            controller={props.register(DOCTORS_FILTER_FIELD_NAME)}
            onHide={handleHide}
            placeholder={appointmentsTranslationKeys.filters.chooseSpecialists}
         >
            <DoctorsFilterList doctors={props.doctors} />
         </Multiselect>
      </StyledDoctorsFilter>
   );
};
